<template>
  <div class="nzmMiaosha">
    <NavBarTab :navs="navs" :choose="nav_choose" :parent_name="info.act_name_chn" />

    <div class="count_down_wrap" v-if="countdown_status === 0 || countdown_status === 1">
      <div class="count_donw_info">距离{{countdown_status === 0 ? '开始':'结束'}}:</div>
      <div class="count_down_time">
        <span class="time">{{count_down_obj.hour}}</span>
        :
        <span class="time">{{count_down_obj.minute}}</span>
        :
        <span class="time">{{count_down_obj.second}}</span>
      </div>
    </div>
    <div class="count_down_wrap" v-else-if="countdown_status === 2">
      <div class="count_donw_info" style="padding-top:.15rem;">已结束</div>
    </div>

    <div class="item_list">
      <div class="item" v-for="item in data_list">
        <MiaoshaItem
          :info="item"
          :click_button="click_button(null,item)"
          :click_img="click_img(null,item)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import click_handler from "../../tools/mgtv/click";
import { openLink } from "../../tools/mgtv/link";
import { getJSON, getJSONP } from "../../api/myaxios";
import { toRem } from "../../tools/tpl";
import Title from "./Title.vue";
import { group_by_size } from "../../tools/group";
import process_award from "../../tools/mgtv/process_award";
import { onUseInfoLoad } from "../../tools/onUseInfoLoad";
import NavBarTab from "./NavBarTab";
import MiaoshaItem from "./NzmMiaosha/MiaoshaItem.vue";
import { countDown as countDownFormat } from "../../tools/countdown";
import { urlToWebp } from "../../tools/tpl";
import addCalendar from "../../tools/mgtv/calendar";
import { click_event } from "../../tools/mgtv/analysis";
import onPageShowListener from "../../tools/onPageShow";

const INIT_QUERY_DATE = "";
let interl_id = null;

const MIAOSHA_INIT = -1;
const MIAOSHA_NOT_BEGIN = 0;
const MIAOSHA_DOING = 1;
const MIAOSHA_END = 2;

const MAX_GET_DETAIL_TIMES = 100;
let get_detail_times = 0;

export default {
  name: "NzmMiaoSha",
  components: { NavBarTab, MiaoshaItem },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          act_name: "vip_benefits_v2",
          act_name_chn: "秒杀模块",
          comp_type: "NzmMiaoSha",
          wrap_style: {
            paddingTop: "0px"
          },
          title: {
            show: true,
            title: "我是秒杀的标题",
            icon: "https://via.placeholder.com/64x32?text=ICON",
            more_url: ""
          },
          config: {
            ms_type: 0 //0 福利秒杀 ，1 购买秒杀
          }
        };
      }
    }
  },
  data: function() {
    return {
      MIAOSHA_INIT,
      MIAOSHA_NOT_BEGIN,
      MIAOSHA_DOING,
      MIAOSHA_END,
      navs: [],
      nav_choose: 0,
      data_list: [],
      countdown_status: MIAOSHA_INIT, //秒杀状态，-1未初始化 ，0未开始,1秒杀中,2已结束
      countdown_diff: -1, //秒杀倒计时
      query_date: INIT_QUERY_DATE
    };
  },
  computed: {
    count_down_obj: function() {
      return countDownFormat(this.countdown_diff * 1000, false);
    }
  },
  methods: {
    get_detail: function(query_date = INIT_QUERY_DATE) {
      //加一层保险，以免把服务器刷坏了
      get_detail_times += 1;
      if (get_detail_times > MAX_GET_DETAIL_TIMES) {
        return;
      }
      const params = {
        act_name: this.info.act_name,
        invoker: window.gact.invoker,
        ticket: window.$bus.user.ticket,
        f_release:window.gact.f_release
      };
      if (query_date !== INIT_QUERY_DATE) {
        //第一次不传参，后面传参。
        params.fs_date = query_date;
      }

      getJSON(
        "//vipact3.api.mgtv.com/api/v1/act/vipbenefits/flashsale/list",
        params,
        10000,
        false,
        true
      ).then(res => {
        if (!res) {
          return;
        }
        if (res.ret === 0) {
          if (!res.data.flashsale_lists) {
            return;
          }
          //导航条
          const t_navs = res.data.dates; //list  [  "2019-09-11",   "2019-09-12",  "2019-09-13" ]
          if (t_navs) {
            const navs = t_navs.map(item => {
              return {
                id: item,
                title: item.replace(/^\d{4}-/, ""),
                handler: () => {
                  this.get_detail(item);
                }
              };
            });
            this.navs = navs;
            // console.log("this.navs", this.navs);
          }

          //秒杀倒计时和状态
          this.countdown_status = res.data.countdown.status;
          this.countdown_diff = res.data.countdown.diff;

          //秒杀产品列表
          const flashsale_lists = res.data.flashsale_lists;
          flashsale_lists.forEach(item => {
            //如果活动已结束，则加上end字段
            if (this.countdown_status === MIAOSHA_END) {
              item.end = 1;
            }
            item.head_img = urlToWebp(item.head_img);

            //秒杀开始的时间戳，用来加入到日历中用
            if (item.note) {
              item.begin_time = new Date(
                item.note.replace(/-/g, "/") + " 20:00"
              ).getTime();
              // console.log(item.begin_time)
            }
          });

          // if (this.countdown_status === MIAOSHA_END) {
          //   flashsale_lists.forEach(item => {
          //     item.end = 1;
          //   });
          // }

          this.data_list = flashsale_lists;
          // console.log("data_list", this.data_list);

          //改变navbar状态
          const nav_choose = this.navs.findIndex(item => {
            return item.id === res.data.query_date;
          });

          if (nav_choose >= 0) {
            this.nav_choose = nav_choose;
          }

          this.query_date = res.data.query_date;

          //未开始和进行中才开始倒计时
          if (
            [MIAOSHA_NOT_BEGIN, MIAOSHA_DOING].indexOf(this.countdown_status) >=
            0
          ) {
            this.start_countdown();
          } else {
            this.stop_countdown();
          }
        }
      });
    },
    click_button: function(event, item) {
      return event => {
        if (this.info.config.ms_type == 0) {
          //福利社
          if (item.received === 1) {
            openLink("https://club.mgtv.com/act/vip_assets/index.html#/awards");
            return;
          }

          if (this.countdown_status === MIAOSHA_NOT_BEGIN) {
            if (item.made_appointment === 0) {
              //进行预约
              this.appoint_fuli(item);
            }
          } else if (this.countdown_status === MIAOSHA_DOING) {
            //已抢光
            if (item.out_stock === 1) {
              return;
            }
            //秒杀福利
            this.flash_fuli(item);
          } else if (this.countdown_status === MIAOSHA_END) {
            //活动已结束
          }
        }
      };
    },
    start_countdown: function() {
      this.stop_countdown();
      interl_id = window.setInterval(this.count_down_cb, 1000);
    },
    stop_countdown: function() {
      window.clearInterval(interl_id);
      interl_id = null;
    },
    count_down_cb: function() {
      if (
        [MIAOSHA_NOT_BEGIN, MIAOSHA_DOING].indexOf(this.countdown_status) >= 0
      ) {
        if (this.countdown_diff == 0) {
          //秒杀倒计时结束，重新获取数据
          this.stop_countdown();
          this.get_detail();
        } else if (this.countdown_diff > 0) {
          this.countdown_diff -= 1;
        }
      } else {
        this.stop_countdown();
      }
    },
    flash_fuli: function(item) {
      //秒杀福利
      click_handler(
        `秒杀福利-${item.award_name}`,
        () => {
          window.$toast.loading({
            mask: true,
            forbidClick: true, // 禁用背景点击
            message: "正在秒杀...",
            duration: 0
          });
          setTimeout(() => {
            getJSON(
              "//vipact3.api.mgtv.com/api/v1/act/vipbenefits/flashsale/get",
              {
                act_name: this.info.act_name,
                award_id: item.award_id,
                ticket: window.$bus.user.ticket
              }
            ).then(res => {
              window.$toast.clear();
              if (!res) {
                window.$toast("请求超时，请重试");
                return;
              }
              if (res.ret === 0) {
                // item.received = 1;
                process_award(res.data);
              } else {
                window.$toast(res.msg);
              }
              //刷新数据
              this.get_detail(this.query_date);
            });
          }, parseInt(Math.random() * 500));
        },
        {
          need_login: true,
          need_act: true,
          need_vip_level: item.growth_level
        }
      );
    },
    appoint_fuli: function(item) {
      //秒杀福利
      click_handler(
        `预约福利-${item.award_name}`,
        () => {
          getJSON("//vipact3.api.mgtv.com/api/v1/act/appointment/make", {
            act_name: this.info.act_name,
            phase: item.award_id,
            ticket: window.$bus.user.ticket
          }).then(res => {
            if (!res) {
              // window.$toast("请求超时，请重试");
              return;
            }
            if (res.ret === 0) {
              item.made_appointment = 1;
              // window.$toast("预约成功");
            } else {
              window.$toast(res.msg);
            }
            if (gact.is_app) {
              // console.log(item);
              addCalendar(
                `芒果TV秒杀提醒:${item.award_name}`,
                item.origin_price > 0 ? `原价${item.origin_price}元现在${item.current_price}元抢，${window.location.href}` : `${item.current_price}元抢，${window.location.href}`,
                item.begin_time,
                10 * 60 * 1000,
                5
              )
                .then(res => {
                  click_event("日历添加成功");
                  window.$act_alert_dialog
                    .show({
                      title: `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.2rem">预约成功</div>
                    <div style="text-align: center;font-size:.28rem;color:#666;margin-bottom:.2rem">芒果TV将在活动开始前提醒您</div>`,
                      button: "我知道了"
                    })
                    .catch(e => {});
                })
                .catch(e => {
                  click_event("日历添加失败" + e);
                  window.$act_alert_dialog
                    .show({
                      title: `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.2rem">预约成功</div>
                    <div style="text-align: center;font-size:.28rem;color:#666;margin-bottom:.2rem">我们将在开抢前5分钟给您发送站内消息提醒，记得打开芒果TV APP的通知哦~</div>`,
                      button: "我知道了"
                    })
                    .catch(e => {});
                  console.error(e);
                });
            }else{
                window.$act_alert_dialog
                    .show({
                      title: `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.2rem">预约成功</div>
                    <div style="text-align: center;font-size:.28rem;color:#666;margin-bottom:.2rem">我们将在开抢前5分钟给您发送站内消息提醒，记得打开芒果TV APP的通知哦~</div>`,
                      button: "我知道了"
                    })
                    .catch(e => {});
            }
          });
        },
        {
          need_login: true,
          need_act: true,
          need_vip_level: item.growth_level
        }
      );
    },
    click_img: function(event, item) {
      return event => {
        openLink(
          `https://club.mgtv.com/act/vipbenefit_2019.html?award_id=${item.award_id}&act_name=${this.info.act_name}&source=${window.gact.source}_pindao`
        );
      };
    }
  },
  created() {
    onUseInfoLoad(() => {
      this.get_detail();
    }, false);
  },
  mounted(){
    onPageShowListener.register('miaosha_refresh',()=>{
       this.get_detail();
    });
  }
};
</script>


<style lang="stylus" scoped>
.nzmMiaosha
  position relative
  width 7.5rem
  padding-bottom .1rem
  .count_down_wrap
    position absolute
    height .6rem
    top 0
    right .4rem
    display flex
    flex-direction column
    .count_donw_info
      color #808080
      font-size .2rem
    .count_down_time
      color #FFC562
      font-size .2rem
      display flex
      justify-content center
      align-items center
      .time
        display block
        background #FFC562
        color white
        font-size .2rem
        padding .02rem .02rem
        margin-top .05rem



  .item_list
    position relative
    display flex
    flex-direction column
    align-items center


</style>
